const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const nonEmptyString = (value: unknown): string | null =>
  typeof value === 'string' && value.trim() ? value.trim() : null;

const validationMessages = (errors: unknown): string[] => {
  if (Array.isArray(errors))
    return errors.map(nonEmptyString).filter((message): message is string => message !== null);
  if (!isRecord(errors)) return [];

  return Object.entries(errors).flatMap(([field, value]) => {
    const messages = Array.isArray(value) ? value : [value];
    return messages
      .map(nonEmptyString)
      .filter((message): message is string => message !== null)
      .map((message) => `${field}: ${message}`);
  });
};

export const extractApiErrorMessage = (error: unknown, fallback: string): string => {
  const rejectedMessage = nonEmptyString(error);
  if (rejectedMessage) return rejectedMessage;
  const apiError = isRecord(error) ? error : null;
  const responseValue = apiError?.response;
  const response = isRecord(responseValue) ? responseValue : null;
  const dataValue = response?.data;
  const data = isRecord(dataValue) ? dataValue : null;

  const message = nonEmptyString(data?.message);
  if (message) return message;

  const details = validationMessages(data?.errors);
  if (details.length > 0) return details.join(' ');

  const detail = nonEmptyString(data?.detail);
  if (detail) return detail;

  const title = nonEmptyString(data?.title);
  if (title) return title;

  const status = typeof response?.status === 'number' ? response.status : null;
  if (status === 400)
    return 'Сервер відхилив дані, але не повернув опис причини. Перевірте поля та спробуйте ще раз.';

  return nonEmptyString(apiError?.message) ?? fallback;
};
